<template>
  <div>
    <b-navbar sticky class="exam__navbar">
      <b-navbar-brand :to="is_room ? {name: 'thi-thu-lich-su'} : (examResponse && examResponse.exam ? { name: 'exam-detail', params: { id: examResponse.exam.id, slug : examResponse.exam.slug } } : '#')" class="exam__back">
        <fa-icon icon="long-arrow-alt-left" /> Trở lại
      </b-navbar-brand>

      <b-navbar-nav>
        <b-nav-text class="exam__title">{{ examDetail ? examDetail.name : '' }}</b-nav-text>
      </b-navbar-nav>
    </b-navbar>
    <template v-if="isLoading">
      <div class="text-center my-5" style="min-height: 50vh">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        
        <div>Loading...</div>
      </div>
    </template>
    <template v-else>
      <b-container fluid>
        <b-row>
          <b-col class="exam__sidebar" cols="12" md="3" lg="3" xl="3">
            <div class="exam__table-content">
              <div class="px-3 py-1">
                <div>
                  <span class="text-center exam__index__question exam__index__question--correct">{{ questionStats.correct }}</span>
                  <span> - Câu trả lời đúng</span>
                </div>
                <div>
                  <span class="text-center exam__index__question exam__index__question--incorrect">{{ questionStats.incorrect }}</span>
                  <span> - Câu trả lời sai</span>
                </div>
                <div>
                  <span class="text-center exam__index__question">{{ questionStats.unanswered }}</span>
                  <span> - Câu không trả lời</span>
                </div>
              </div>

              <template v-for="skill in examIndexList">
                <div :key="skill.id" class="exam__index__skill">
                  <h4 class="exam__index__title">{{ skill.name }}</h4>

                  <template v-b-scrollspy="{ element: `#scrollspy-${examDetail ? examDetail.id : ''}`, offset: 96 }">
                    <b-container>
                      <b-row no-gutters>
                        <template
                          v-for="item in skill.questions"
                        >
                          <b-col :key="item.id" cols="3" lg="2">
                            <div class="text-center">
                              <a :ref="`question-${item.id}`" :href="`#item-${item.number}`" :class="'exam__index__question ' + checkQuestionResponse(item)" @click="questionIndexClick">{{ item.number }}</a>
                            </div>
                          </b-col>
                        </template>
                      </b-row>
                    </b-container>
                  </template>
                </div>
              </template>
            </div>
          </b-col>
          <b-col class="exam__primary" cols="12" md="9" lg="9" xl="9">
            <div :id="`scrollspy-${examDetail ? examDetail.id : ''}`">
              <template v-for="skill in examDataList">
                <div :key="skill.id" class="exam__skill__wrapper">
                  <div class="exam__skill__title">{{ skill.name }}</div>

                  <template v-for="part in skill.parts">
                    <div :key="part.id" class="exam__part__wrapper">
                      <div class="exam__part__title">{{ part.name }}</div>
                      <div v-html="part.description" class="exam__part__description"></div>
                      
                      <template v-for="question in part.questions">
                        <template v-if="question.typeEnum === 'single'">
                          <QuestionSingle :key="question.id" :id="`item-${question.number}`" :data-id="question.id" :data-type="`${question.typeEnum}-${question.type}`" class="question__item" :parent="null" :question="question" :editable="false" :response="getQuestionResponse(question.id)" :isExplain="true"/>
                        </template>
                        <template v-else>
                          <QuestionGroup :key="question.id" :question="question" :editable="false" :response="examResponse.response" class="question__group__wrapper" :isExplain="true"/>
                        </template>
                      </template>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { STORE_KEY } from '../_store/constants'
import QuestionSingle from './QuestionSingle'
import QuestionGroup from './QuestionGroup'

export default {
  name: 'ExamResultDetail',
  data() {
    return {
      id: this.$route.params.id,
      is_room: false
    }
  },
  components: {
    QuestionSingle,
    QuestionGroup
  },
  computed: {
    ...mapGetters({
      examDetail: `${STORE_KEY}/examDetail`,
      examIndexList: `${STORE_KEY}/examIndexList`,
      examDataList: `${STORE_KEY}/examDataList`,
      examAudioList: `${STORE_KEY}/examAudioList`,
      examResponse: `${STORE_KEY}/examResponse`,
      isLoading: `${STORE_KEY}/isLoading`,
    }),
    questionStats() {
      let correct = 0
      let incorrect = 0
      let unanswered = 0

      if (Array.isArray(this.examIndexList)) {
        this.examIndexList.forEach(skill => {
          if (Array.isArray(skill.questions)) {
            skill.questions.forEach(question => {
              const resStatus = this.checkQuestionResponse(question)
              if (resStatus === 'exam__index__question--correct') {
                correct++
              } else if (resStatus === 'exam__index__question--incorrect') {
                incorrect++
              } else {
                unanswered++
              }
            })
          }
        })
      }

      return {
        correct,
        incorrect,
        unanswered
      }
    }
  },
  beforeMount() {
    this.getExamResponse(this.id);
  },
  watch: {
    examDetail () {
      this.is_room = this.examDetail.is_room
    }
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ['getExamResponse']),
    questionIndexClick(e) {
      e.preventDefault()
      const href = e.target.getAttribute('href')
      const el = href ? document.querySelector(href) : null
      if (el) {
        window.scrollTo(0, el.offsetTop - 15)
      }
    },
    checkQuestionResponse(question) {
      if (!this.examResponse || !Array.isArray(this.examResponse.response)) return ''
      const res = this.examResponse.response.find(item => {
        return item.question_id === question.id
      })

      if (!res) return ''

      let isAnswered = false
      let isCorrect = false

      if ('answer_id' in res) {
        if (res.answer_id !== null && res.answer_id !== undefined && res.answer_id !== '' && res.answer_id !== -1) {
          isAnswered = true
          if (Array.isArray(question.answers)) {
            question.answers.forEach(answer => {
              if (answer.is_answer && answer.id == res.answer_id) {
                isCorrect = true
              }
            })
          }
        }
      } else {
        if (res.answer !== null && res.answer !== undefined && String(res.answer).trim() !== '') {
          isAnswered = true
          if (Array.isArray(question.answers)) {
            question.answers.forEach(answer => {
              if (answer.text_answer != null) {
                if (String(answer.text_answer).toLowerCase() == String(res.answer).toLowerCase()) {
                  isCorrect = true
                }
              } else if (answer.content != null) {
                if (String(answer.content).toLowerCase() == String(res.answer).toLowerCase()) {
                  isCorrect = true
                }
              }
            })
          }
        }
      }

      if (!isAnswered) return ''
      return isCorrect ? 'exam__index__question--correct' : 'exam__index__question--incorrect'
    },
    getQuestionResponse(id) {
      let response
      
      if (this.examResponse) {
        this.examResponse.response.forEach(item => {
          if (item.question_id === id) {
            response = item
          }
        })
      }
      
      return response
    }
  }
};
</script>
